module.exports = __webpack_public_path__ + "img/nav-design-hammered@2x.e1f8693.webp";